import { get, pickBy } from 'lodash';
import { formatDate, getApprovers } from './common';
import { mapAuthorisersGroup } from '../../utils/authoriserUtils';
import { getApproversPayload } from './common';

const getAuthorisersGroup = (bacsDetails) => get(bacsDetails, 'authorisersGroup', []);

export const getBacsReviewRequest = (bacsCreditDetails) =>
	JSON.stringify({
		source_id: bacsCreditDetails.id,
		account_ids: [bacsCreditDetails.fromAccount],

		amount: {
			value: parseFloat((bacsCreditDetails.total || '').replace(/,/g, '')) || 0.0,
			currency: 'GBP',
		},
		payment_date: formatDate(bacsCreditDetails.settlementDate),
		payment_category: 'BCR',
	});

export const getBacsDebitReviewRequest = (bacsDebitDetails) =>
	JSON.stringify({
		source_id: bacsDebitDetails.id,
		account_ids: [bacsDebitDetails.toAccount],

		amount: {
			value: parseFloat((bacsDebitDetails.total || '').replace(/,/g, '')) || 0.0,
			currency: 'GBP',
		},
		payment_date: formatDate(bacsDebitDetails.settlementDate),
		payment_category: 'BDB',
	});

export const getCreditor = ({ id, beneficiary_id, amount, reference, hmrcReference, toAccount }, payees) => {
	const isExternal = payees.some((payee) => payee.id === toAccount);
	return {
		id,
		beneficiary_id: isExternal ? toAccount : beneficiary_id,
		amount: { value: parseFloat((amount || '').replace(/,/g, '')) || 0.0, currency: 'GBP' },
		...(reference ? { reference } : {}),
		hmrc_reference: hmrcReference,
	};
};

const getCreditors = ({ payments = [] }, payees) => payments.map((payment) => getCreditor(payment, payees));

export const getBacsConfirmedRequest = (bacsCreditDetails, payees, paymentContextId) => {
	const groupApprovers = { approval_group_approver_id: mapAuthorisersGroup(getAuthorisersGroup(bacsCreditDetails)) };
	const namedApprovers = { approver_id: get(bacsCreditDetails, 'authorisers', []).map((authoriser) => authoriser.id) };
	const approversPayload = getApproversPayload(namedApprovers, groupApprovers);

	return JSON.stringify(
		pickBy({
			source_id: bacsCreditDetails.id,
			bacs_id: bacsCreditDetails.bacsId,
			payment_context_id: paymentContextId,
			submission_date: formatDate(bacsCreditDetails.submissionDate),
			settlement_date: formatDate(bacsCreditDetails.settlementDate),
			payment_name: bacsCreditDetails.paymentName,
			entries: getCreditors(bacsCreditDetails, payees),
			...(!!approversPayload && approversPayload),
			batch_type: bacsCreditDetails.batch_type,
		})
	);
};

export const getDebitor = ({ id, amount, reference, transactionCode, beneficiary_id, fromAccount }, payees) => {
	const isExternal = payees.some((payee) => payee.id === fromAccount);
	return {
		id,
		beneficiary_id: isExternal ? fromAccount : beneficiary_id,
		amount: { value: parseFloat((amount || '').replace(/,/g, '')) || 0.0, currency: 'GBP' },
		...(reference ? { reference } : {}),
		transaction_code: transactionCode,
	};
};

const getDebitors = (payments = [], payees) => payments.map((payment) => getDebitor(payment, payees));

export const getBacsDebitConfirmedRequest = (bacsDebitDetails, payees, paymentContextId) => {
	const { id, bacsId, submissionDate, settlementDate, paymentName, payments, batch_type } = bacsDebitDetails;

	const groupApprovers = { approval_group_approver_id: mapAuthorisersGroup(getAuthorisersGroup(bacsDebitDetails)) };
	const namedApprovers = { approver_id: get(bacsDebitDetails, 'authorisers', []).map((authoriser) => authoriser.id) };
	const approversPayload = getApproversPayload(namedApprovers, groupApprovers);

	return JSON.stringify(
		pickBy({
			source_id: id,
			payment_context_id: paymentContextId,
			bacs_id: bacsId,
			submission_date: formatDate(submissionDate),
			settlement_date: formatDate(settlementDate),
			payment_name: paymentName,
			entries: getDebitors(payments, payees),
			...(!!approversPayload && approversPayload),
			batch_type,
		})
	);
};
